import CustomField from '../CustomField';
import { sanitizeUrl } from 'javascripts/sanitizer';

export default class UrlCustomField extends CustomField {
  exampleContents() {
    return {
      text: 'example.com',
      url: '#',
    };
  }

  contentsForRecord(record) {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.value) {
      return {
        text: customFieldValue.value,
        externalUrl: sanitizeUrl(customFieldValue.value),
      };
    }

    return {};
  }
}
